import Paper from "@material-ui/core/Paper";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { Color, responsiveSidePadding, topBarHeight } from "../../theme";
import { HasTestId, PlainFunctionComponent } from "../../types";

export interface TopBarProps extends HasTestId {
    breadcrumbNavigation: React.ReactNode;
    topActions?: React.ReactNode;
}

export const TopBar: PlainFunctionComponent<TopBarProps> = ({ breadcrumbNavigation, testId, topActions }) => {
    const classes = useStyles();

    return (
        <Paper className={classes.topBar} data-testid={testId} elevation={0} square={true}>
            {breadcrumbNavigation}
            {topActions}
        </Paper>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        topBar: {
            alignItems: "center",
            borderBottom: "1px solid",
            borderBottomColor: Color.grey3,
            display: "flex",
            height: topBarHeight,
            ...responsiveSidePadding(theme, 24),
        },
    }),
);
